export const ROUTES_LINKS = {
    LINK_HOMEPAGE: '/',
    LINK_CATALOG: '/catalog',
    LINK_CATALOG_ITEM: `/catalog/:id`,
    LINK_CATALOG_ITEMS: `/catalog/products/:id`,
    LINK_NEWS: '/news',
    LINK_NEWS_ITEM: '/news/:id',
    LINK_LOGIN: '/login',
    LINK_REGISTRATION: '/registration',
    LINK_CART: '/cart',
    LINK_FAVORITE: '/favorite',
    LINK_BLOG: '/blog',
    LINK_BLOG_ITEM: '/blog/:id',
    LINK_SEARCH: '/search',
    LINK_PROFILE: '/profile',
    LINK_DOCUMENTATIONS: '/documentations',
    LINK_TRAINING: '/training',
    LINK_ABOUT: '/about',
    LINK_CONTACTS: '/contacts',
    LINK_QUESTIONS: '/faq',
    LINK_ORDER_SUCCESS: '/success',
    LINK_NOTFOUND: '*',
}
